<script setup>

const props = defineProps({
  footer: {
    type: Object,
    default: () => ({})
  },
  cloud_app: {
    type: Array,
    default: () => []
  }
})

const cloudApps = computed(() => {
  const position1 = []
  const notPosition1 = []

  for (const item of props.cloud_app) {
    if (Number(item.position) === 1) {
      position1.push(item)
    } else {
      notPosition1.push(item)
    }
  }

  return {
    position1,
    notPosition1
  }
})
</script>

<template>
  <div class="Heziyun-cloudMarket Heziyun-padding">
    <div class="Heziyun-defaultWidth">
      <div class="Heziyun-commodity-title">
        <span v-intersect="{ class: 'bottom-top', delay: 0 }">
          {{ $t('index.cloudMarket') }}
        </span>
        <p v-intersect="{ class: 'bottom-top', delay: 100 }">
          {{ $t('index.cloudMarket2') }}
        </p>
      </div>

      <div class="Heziyun-market">
        <div class="Heziyun-sketch" v-intersect="{ class: 'left-right', delay: 0 }">
          <div class="Heziyun-text">
            {{ footer.cloud_app_tips || '' }}
          </div>

          <div class="Heziyun-quartile">
            <div
              v-for="item in cloudApps.notPosition1"
              :key="item.id"
              class="Heziyun-item"
            >
              <img
                :src="item.img"
                :alt="item.name"
                loading="lazy"
              >
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>

        <div class="Heziyun-grid" v-intersect="{ class: 'right-left', delay: 0 }">
          <a
            v-for="item in cloudApps.position1"
            :key="item.id"
            href="/cart/goodsList.htm"
            class="Heziyun-itemN"
          >
            <img
              :src="item.img"
              :alt="item.name"
              loading="lazy"
            >
            <p>{{ item.name }}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.Heziyun-cloudMarket {
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2), rgba(0, 0, 0, 0.1));

  @keyframes rotates {
    to {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @keyframes rotateReverse {
    to {
      transform: translate(-50%, -50%) rotate(-360deg);
    }
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200%;
    height: 200%;
    background: conic-gradient(
      from 0deg,
      rgba(255, 154, 162, 0.4),
      rgba(255, 183, 178, 0.58),
      rgba(255, 218, 193, 0.51),
      rgba(226, 240, 203, 0.57),
      rgba(255, 183, 178, 0.55)
    );
    transform: translate(-50%, -50%);
    animation: rotates 8s linear infinite;
    filter: blur(50px);
    opacity: 0.3;
    z-index: -1;
  }

  &::after {
    width: 180%;
    height: 180%;
    animation: rotateReverse 10s linear infinite;
  }

  .Heziyun-defaultWidth {
    margin: 0 15rem;

    .Heziyun-commodity-title {
      position: relative;
    }

    .Heziyun-market {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 5rem;

      .Heziyun-sketch {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        width: 45%;

        .Heziyun-text {
          color: #666;
          line-height: 2;
          font-size: 0.9rem;
        }

        .Heziyun-quartile {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
          color: #253554;
          font-size: 0.9rem;

          .Heziyun-item {
            display: flex;
            align-items: center;
            gap: 0.3rem;
            padding: 0.5rem;
            background-color: #ffffff4a;
            backdrop-filter: blur(10px);

            img {
              width: 1.2rem;
              height: 1.2rem;
              object-fit: contain;
            }
          }
        }
      }

      .Heziyun-grid {
        display: grid;
        grid-template-columns: repeat(3, auto);
        gap: 1.5rem;
        justify-items: end;

        .Heziyun-itemN {
          display: flex;
          align-items: center;
          flex-direction: column;
          gap: 1rem;
          width: 8rem;
          padding: 1.2rem 0;
          border: 2px solid #ffffff61;
          border-radius: 10px;
          background-image: linear-gradient(0deg, #ffffff36, #f3f5f8);
          box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1), -8px -8px 20px #ffffff7d;
          backdrop-filter: blur(10px);

          &:hover {
            background-color: #f3f5f8;
            box-shadow: inset 8px 8px 20px rgba(55, 99, 170, 0.11), inset -8px -8px 20px #fff;
          }

          img {
            width: 2.5rem;
            height: 2.5rem;
            object-fit: contain;
          }

          p {
            text-align: center;
            line-height: 1.6;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .Heziyun-cloudMarket {
    .Heziyun-defaultWidth {
      margin: 0;
      font-family: "思源黑";

      .Heziyun-market {
        display: grid;
        grid-template-columns: 1fr;
        gap: 5vw;

        .Heziyun-sketch {
          width: 100%;
          gap: 3vw;

          .Heziyun-text {
            font-size: 3.5vw;
          }

          .Heziyun-quartile {
            gap: 4vw;
            font-size: 3.5vw;

            .Heziyun-item {
              gap: 1vw;
              padding: 2vw;

              img {
                width: 4vw;
                height: 4vw;
              }
            }
          }
        }

        .Heziyun-grid {
          width: 100%;
          gap: 3vw;
          grid-template-columns: repeat(2, 1fr);

          .Heziyun-itemN {
            width: 100%;
            gap: 3vw;
            padding: 2vw;
            font-size: 3.5vw;
            border-radius: 2vw;

            img {
              width: 8vw;
              height: 8vw;
            }
          }
        }
      }
    }
  }
}
</style>